import { createContext, useContext } from 'react';

interface GTContextValue {
  itemHeight: number;
  portalTarget: HTMLElement | null;
}

const GTContext = createContext<GTContextValue>({ itemHeight: 77, portalTarget: null });

export const GTProvider = GTContext.Provider;

export const useGTContext = () => useContext(GTContext);

export const useGTPortalTarget = () => useGTContext().portalTarget;
